
import React, { useState, useEffect, useRef, useCallback, useReducer } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined } from '@mui/icons-material';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Autocomplete,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Search from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';

import ToggleSplitPane from '../components/ToggleSplitPane';

import AlertNotification from '../components/AlertNotification';
import SearchCase from '../TestModules/SearchCase';

import {
  TextFieldWithIconButton,
  UtilityLibrary,
  ApiManager,
  sessionService,
  SessionManager,
  PageLoader,
  DocumentUtility,
  EnumUtility,
  NotificationDialog,
  DeterminePermissions,
  ErrorModel,
  LoggerUtility,
  CommonDialog,
} from '../components/ComponentsLibrary';
import { findAllByDisplayValue } from '@testing-library/react';
import { json } from 'react-router-dom';


const ManageTestCase = ({ }) => {

    const [pageTitleCurrent, setPageTitleCurrent] = useState("YTrac :: Case Info Test Page");


    useEffect(() => {
        document.title = pageTitleCurrent;
    }, [pageTitleCurrent]);


    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    

    const [leftPaneTitle, setLeftPaneTitle] = useState("Test Component");
    const [rightPaneTitle, setRightPaneTitle] = useState("Document Viewer");

    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedData, setSelectedData] = useState([]);


    const [isPageLoading, setIsPageLoading] = useState(false);

    const customDateFormat = "MM/DD/YYYY hh:mm A";

    const handleSelectCaseClick = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleRowSelect = async (rowData) => {
        const params = {
            caseNumber: rowData.caseNumber,
            masterServerDBSchema,
        };
        const newCaseData = await ApiManager.GetCaseDataFromApiByID(params);
        if (newCaseData && newCaseData.length > 0) {
            setSelectedData(newCaseData[0]);
        }

        // You can also perform additional actions here
    };


    const leftPaneContent = (
        <div className="content-main-container">
            <div className="pane-wrap-container">

                <div className="pane-main-container-v01">
                    {/* Header Section */}
                    <header className="form-header">
                        <div className="text-wrapper-header" style={{ padding: '5px 5px' }}>Test Page</div>
                    </header>
                    {/* Form Section */}
                    <div className='form-content'>
                        <div style={{ padding: '16px', width: '100%' }}>
                            {/* Top Section (Yellow) */}
                            <div className="form-caseInfo-container">
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">Case ID:</label>
                                    <label id="caseNumberLbl" name="caseNumberLbl" className="text-wrapper-subtitle caseInfo-Content">{selectedData.caseNumber || ''}</label>
                                </div>
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">CP:</label>
                                    <label id="cpNameLbl" name="cpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{(selectedData.cpFirstName || ' ') + ' ' + (selectedData.cpLastName || ' ')}</label>
                                </div>
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">CP SSN:</label>
                                    <label id="cpSSNLbl" name="cpSSNLbl" className="text-wrapper-subtitle caseInfo-Content">{selectedData.cpssn || ''}</label>
                                </div>

                            </div>
                            <div className="form-caseInfo-container">
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">Case Worker:</label>
                                    <label id="caseWorkerLbl" name="caseWorkerLbl" className="text-wrapper-subtitle caseInfo-Content">{selectedData.CaseWorker || ''}</label>
                                </div>
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">NCP:</label>
                                    <label id="ncpNameLbl" name="ncpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{(selectedData.ncpFirstName || '') + ' ' + (selectedData.ncpLastName || '')}</label>
                                </div>
                                <div className="form-caseInfo-field">
                                    <label className="text-wrapper-subtitle caseInfo-Title">NCP SSN:</label>
                                    <label id="ncpSSNLbl" name="ncpSSNLbl" className="text-wrapper-subtitle caseInfo-Content">{selectedData.ncpssn || ''}</label>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* Footer Section */}
                    <footer className="form-footer">
                        <div className="d-flex justify-content-between align-items-center mb-2 form-actions">

                            <div className='leftDiv'>
                                <Button id="testErrorBtn" name="cancelBtn" variant='outlined' className='me-3' onClick={handleSelectCaseClick}>Select a Case</Button>
                            </div>

                            <div className='rightDiv'>

                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </div >
    );

    const rightPaneContent = (
        <div className="content-main-container">
            <div className="pane-wrap-container">
                <div className="pane-main-container">
                    <div className="form-section">

                    </div>
                </div>
            </div>
        </div >
    );

    return (
        <div>
            <ToggleSplitPane
                leftPaneTitle={leftPaneTitle}
                leftPaneContent={leftPaneContent}
                rightPaneTitle={rightPaneTitle}
                rightPaneContent={rightPaneContent}
                leftPaneSize='50%'
            >
            </ToggleSplitPane>


            <CommonDialog
                openDialog={dialogOpen}
                onCloseDialog={handleCloseDialog}
                title="Search Case"
            >
                <SearchCase
                    onRowSelect={handleRowSelect}
                    onClose={handleCloseDialog}
                />
            </CommonDialog>

            {/* Include the loader component */}
            <PageLoader isPageLoading={isPageLoading} />
        </div>
    );
};

export default ManageTestCase;
